<mat-tab-group *ngIf="survey?.Channel > -1" mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Reporting">
    <app-reports [survey]="survey" [interview]="interview" [modelChecked]="modelChecked" [test]="true"></app-reports>
  </mat-tab>
  <mat-tab label="Exports">
    <app-automations></app-automations>
  </mat-tab>
</mat-tab-group>
